import { AlertTitle } from "@mui/material";
import { DefaultAlert } from "./Messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createForm } from "@/hooks/form/source-data/useForm";
import { AppSettings } from "@/AppSettings";
import { FC } from "react";
import { createEvent } from "@/hooks/form/source-data/useEvent";
import { ConfigurationStatus, Participant } from "@/api/dtos";

interface IExcludedParticipantAlertProps {
    participant: Participant | undefined;
}

const ExcludedParticipantAlert: FC<IExcludedParticipantAlertProps> = ({ participant }) => {
    if (participant?.status !== ConfigurationStatus.Disabled) {
        return null;
    }

    return (
        <DefaultAlert sx={{ mb: -2 }} icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertDefault} />}>
            <AlertTitle>Participant Excluded</AlertTitle>
            <p>
                The participant has been excluded.
            </p>
            <p>
                <strong>Reason:</strong> The participant has been disabled in the Source Data Verification system.
            </p>
        </DefaultAlert>
    )
}

export default ExcludedParticipantAlert;